import { useEffect, useState } from "react";
import Footer from "./small/Footer";
import { Icon } from "@iconify/react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { useAuth } from "./firebase";
import { app } from "./firebase";
import { db, firestoredb } from "./firebase";
import { toast, ToastContainer } from "react-toastify";
import {
  collection,
  addDoc,
  doc,
  setDoc,
  updateDoc,
  getDoc,
} from "firebase/firestore";
import { updateProfile } from "firebase/auth";
import { storage, uploadImg } from "./firebase";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { async } from "@firebase/util";

const CreateCollection = () => {
  const currentUser = useAuth();
  const [image, setImage] = useState(null);
  const [imageURL, setImageURL] = useState(null);
  const [url, setUrl] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [bio, setBio] = useState("");
  const [website, setWebsite] = useState("");
  const [facebook, setFacebook] = useState("");
  const [blockchain, setBlockchain] = useState("");
  const [unlockable, setUnlockable] = useState("");
  const [explicit, setExplicit] = useState("");
  const [supply, setSupply] = useState("");
  const [collections, setCollection] = useState([]);
  const [photoURL, setPhotoURL] = useState("");
  const [description, setDescription] = useState("");
  const [loadingState, setLoadingState] = useState(false);
  const [walletAddress, setWalletKey] = useState("");
  const [documentId, setDocumentId] = useState("");

  const addData = () => {};

  const handleImagechange = async (e) => {
    if (e.target.files[0]) {
      setLoadingState(true);
      setImage(e.target.files[0]);
      const imgURI = URL.createObjectURL(e.target.files[0]);
      setImageURL(imgURI);
      console.log(e.target.files[0]);
      // uploadImg(e.target.files[0], currentUser);

      const imageRef = ref(storage, currentUser?.uid + e.target.files[0].name);
      const snapshot = await uploadBytes(imageRef, e.target.files[0]);
      const imageLink = await getDownloadURL(imageRef);
      setPhotoURL(imageLink);
      console.log(imageLink);
      setLoadingState(false);
      // document.getElementById("header-prof-pic").src = imgURI;
    }
  };

  const handleSubmit = async () => {
    // if (window.solana != null && window.solana.publicKey != null) {
    //   setWalletAddress(window.solana.publicKey.toString());
    // }
    console.log(name);
    console.log(description);
    console.log(photoURL);

    const docRef = await addDoc(
      collection(firestoredb, "metamuze_CreateCollection"),
      {
        walletAddress: walletAddress,
        collectionName: name,
        collectionImg: photoURL,
        description: description,
      }
    );
    setDocumentId(docRef);
    console.log(docRef);
  };

  const walletListner = async () => {
    // console.log(window.solana);

    // @ts-ignore
    const { solana } = window;

    if (solana) {
      try {
        const response = await solana.connect();
        // console.log("wallet account ", response.publicKey.toString());
        // console.log(response.publicKey.toString());

        setWalletKey(response.publicKey.toString());
      } catch (err) {
        // { code: 4001, message: 'User rejected the request.' }
      }
    }
  };

  useEffect(() => {
    walletListner();
  }, []);

  return (
    <>
      <main className="create-own-bg">
        <section className="makeownbanner">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-sm-12">
                <h3 className="createyourown">
                  Create
                  <span> Collection </span>
                </h3>
              </div>

              {/* <div className="col-sm-6">
                <img
                  className="img-fluid card-img-create"
                  src="../../assets/images/createyourown/card-img.png"
                  alt=""
                />
              </div> */}
            </div>
          </div>
        </section>

        <section className="create-body">
          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="craete-tit">Image, Video, Audio, or 3d Model</h3>
                <p className="create-txt">
                  File types supported : JPG, PNG, GIF, SVG, MP4, WEBM, WAV,
                  OGG, GLB, GLTF . Max size : 100MB
                </p>
              </div>
            </div>
          </div>
          <div className="container  nft-body">
            <div className="row align-items-center">
              <div className="col-sm-4">
                <label>
                  {imageURL == null ? (
                    <img
                      className="img-picker"
                      src="../../assets/images/createyourown/chooseimg.png"
                      alt=""
                    />
                  ) : (
                    <img className="img-fluid" src={imageURL} alt="" />
                  )}

                  <input
                    type="file"
                    className="choose-a-file"
                    onChange={handleImagechange}
                  />
                </label>
              </div>
              <div className="col-sm-8">
                <div className="rigt-side-wrap">
                  <h3 className="craete-tit">Name :</h3>
                  <input
                    className="create-input-txt mt-2"
                    placeholder="Item Name"
                    type="text"
                    onChange={(e) => setName(e.target.value)}
                  />
                  <div className="spacer-create"></div>
                  <h3 className="craete-tit mb-2">Description</h3>

                  <textarea
                    rows="4"
                    className="textareadescription"
                    placeholder="Provide a detailed description of your item."
                    onChange={(e) => setDescription(e.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12  text-end">
                <button className="createitembtn" onClick={handleSubmit}>
                  Create
                </button>
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </main>
    </>
  );
};
export default CreateCollection;
